// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';

// const ProductDetail = () => {
//   const { id } = useParams();
//   const [product, setProduct] = useState(null);

//   useEffect(() => {
//     fetch(`https://fakestoreapi.com/products/${id}`)
//       .then(res => res.json())
//       .then(json => setProduct(json))
//       .catch(err => console.log(err));
//   }, [id]);

//   if (!product) return <div>Loading...</div>;

//   return (
//     <section className="product-detail container">
//       <div className="item">
//         <img src={product.image} alt={product.title} />
//         <h3>{product.title}</h3>
//         <p>{product.description}</p>
//         <p>{product.category}</p>
//         <p>${product.price}</p>
//       </div>
//       <form>
//          <label>Quantity</label>
//          <select>
//              <option value="1">1</option>
//              <option value="2">2</option>
//              <option value="3">3</option>
//          </select>
//          <button>Add to Cart </button>
//      </form>
//      <hr/>
//     </section>
//   );
// }

// export default ProductDetail;
import {useContext} from 'react';
import React from 'react'
import ProductsContext from "../context/ProductsContext"
import CartContext from '../context/CartContext';
import {useParams,useNavigate, Link} from 'react-router-dom';

const ProductDetail = () => {
  const params = useParams();
  const navigate = useNavigate();

const {products,setProducts} = useContext(ProductsContext);
const {cart,setCart} = useContext(CartContext);

let product = products.filter((prod)=>{
  if(prod.id === Number(params.id)) return prod;
})[0];
// console.log('product',product);

//Kreiranje option menija u select elementu
const xxx = product.rating.count;
let option = [];
for(let i = 1; i < xxx; i++){
  option.push(<option key={i} value={i}>{i}</option>)
}

// console.log(xxx);
/*ako postoji isti el u kolicima uzmi filter da li si uzeo isti el i povecaj kolicinu*/

// cart.some((item)=>{
//   return item.id === params.id
// }) ? cart.filter((item)=>{
//   if(item.id === params.id){
//     return item;
//   }
// })[0].qty += Number(e.target.selectQty.value):


//CART
const addToCart = (e) => {
  e.preventDefault();
  cart.some((item)=>{
    return item.id === params.id
  }) ? cart.filter((item)=>{
    if(item.id === params.id){
      return item;
    }
  })[0].qty += Number(e.target.selectQty.value):
  setCart((cart)=> [...cart,{
    id:params.id,
    title:product.title,
    price:product.price,
    image:product.image,
    qty:Number(e.target.selectQty.value)
  }])
  navigate("/products");
}

// console.log(selectQty.value);
// console.log(params.id);
  return (
    <section className="product-detail container">
  <div className="item">
    <img src={product.image} alt={product.title} style={{width:'100px'}}/>
    <h3>{product.title}</h3>
    <p>{product.description}</p>
    <p>Category: &nbsp; 
      {product.category}</p>
    <p>Price:
      ${product.price}</p>
  </div>
  <form onSubmit={addToCart}>

     <label>Quantity</label>
     <select name="selectQty">
      {option}
         {/* <option value="1">1</option>
         <option value="2">2</option>
         <option value="3">3</option> */}
     </select>
     <button>Add to Cart</button>
 </form>
 <hr/>
</section>

  )

}

export default ProductDetail
